/**
 * wayai update — update CLI to the latest version
 */

import { execFileSync } from 'node:child_process';
import { captureException, closeSentry } from '../lib/sentry.js';

export async function updateCommand(pkg: { version: string }): Promise<void> {
  console.log(`Current version: ${pkg.version}`);
  console.log('Checking for updates...');
  try {
    // shell: true required for Windows where npm is a .cmd script
    const latest = execFileSync('npm', ['view', '@wayai/cli', 'version'], {
      timeout: 10000,
      shell: true,
    }).toString().trim();
    if (latest === pkg.version) {
      console.log(`Already on the latest version (${pkg.version}).`);
    } else {
      console.log(`Updating ${pkg.version} → ${latest}...`);
      execFileSync('npm', ['install', '-g', '@wayai/cli@latest'], {
        timeout: 60000,
        shell: true,
        stdio: 'inherit',
      });
      console.log(`Updated to ${latest}.`);
    }
  } catch (err) {
    captureException(err);
    await closeSentry();
    console.error('Update failed:', err instanceof Error ? err.message : String(err));
    console.error('Try manually: npm install -g @wayai/cli');
    process.exit(1);
  }
}
